export const TERMINALS = [
  { id: 1, name: "iPhone" },
  { id: 2, name: "Android" },
  { id: 3, name: "パソコン・その他" }
];
export const PROXY_LOGINS = [
  { id: 1, name: "得た" },
  { id: 2, name: "得ていない" }
];
